import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tax-requests',
  templateUrl: './tax-requests.component.html',
  styleUrls: ['./tax-requests.component.scss']
})
export class TaxRequestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
